/**
 * Loads jQuery + Slick once, and defers slider work until near viewport.
 * Reduces main-thread blocking on first paint.
 */
(function (window, document) {
  var JQUERY_SRC = 'https://code.jquery.com/jquery-3.6.0.min.js';
  var SLICK_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js';
  var SLICK_CSS = [
    'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.css',
    'https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.min.css',
  ];

  var loadPromise = null;
  var cssStarted = false;
  var pending = window.LamimoSlickQueue || [];

  function loadStylesheet(href) {
    if (document.querySelector('link[href="' + href + '"]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function ensureCss() {
    if (cssStarted) return;
    cssStarted = true;
    SLICK_CSS.forEach(loadStylesheet);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-lamimo-src="' + src + '"], script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.lamimoLoaded === 'true' || (src.indexOf('jquery') !== -1 && window.jQuery) || (src.indexOf('slick') !== -1 && window.jQuery && jQuery.fn && jQuery.fn.slick)) {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          existing.dataset.lamimoLoaded = 'true';
          resolve();
        });
        existing.addEventListener('error', reject);
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.dataset.lamimoSrc = src;
      script.onload = function () {
        script.dataset.lamimoLoaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ready() {
    if (window.jQuery && jQuery.fn && jQuery.fn.slick) {
      ensureCss();
      return Promise.resolve(window.jQuery);
    }
    if (loadPromise) return loadPromise;

    ensureCss();
    loadPromise = loadScript(JQUERY_SRC)
      .then(function () {
        return loadScript(SLICK_SRC);
      })
      .then(function () {
        return window.jQuery;
      });

    return loadPromise;
  }

  function runIdle(fn, options) {
    options = options || {};
    if (options.idle === false) {
      fn();
      return;
    }
    var timeout = options.idleTimeout != null ? options.idleTimeout : 1500;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        fn();
      }, { timeout: timeout });
      return;
    }
    setTimeout(fn, options.delay != null ? options.delay : 1);
  }

  function observe(el, onVisible, options) {
    options = options || {};
    if (!el) {
      onVisible();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      onVisible();
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries.some(function (entry) {
          return entry.isIntersecting;
        });
        if (!visible) return;
        observer.disconnect();
        onVisible();
      },
      {
        root: null,
        rootMargin: options.rootMargin || '280px 0px',
        threshold: options.threshold != null ? options.threshold : 0.01,
      }
    );
    observer.observe(el);
  }

  function whenVisible(el, callback, options) {
    options = options || {};
    observe(
      el,
      function () {
        ready().then(function ($) {
          runIdle(function () {
            callback($);
          }, options);
        });
      },
      options
    );
  }

  function whenVisibleOnly(el, callback, options) {
    options = options || {};
    observe(
      el,
      function () {
        runIdle(callback, options);
      },
      options
    );
  }

  function whenReady(callback, options) {
    options = options || {};
    ready().then(function ($) {
      runIdle(function () {
        callback($);
      }, options);
    });
  }

  var api = {
    ready: ready,
    whenReady: whenReady,
    whenVisible: whenVisible,
    whenVisibleOnly: whenVisibleOnly,
  };

  window.LamimoSlick = api;

  pending.forEach(function (item) {
    if (!item || !item[0]) return;
    var method = item[0];
    if (method === 'whenVisible') api.whenVisible(item[1], item[2], item[3]);
    else if (method === 'whenVisibleOnly') api.whenVisibleOnly(item[1], item[2], item[3]);
    else if (method === 'whenReady') api.whenReady(item[1], item[2]);
    else if (method === 'ready' && typeof item[1] === 'function') api.ready().then(item[1]);
  });
  window.LamimoSlickQueue = [];
})(window, document);
